import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { useUserPowerplants, useUserRole } from '../api/GetData';
import useMediaQuery from '@mui/material/useMediaQuery';
import SettingsIcon from '@mui/icons-material/Settings';
import './navbar.css'
import { ConfigPopup } from './ConfigPopup';
import { SidebarConfigPopup } from "./SidebarConfigPopup"; 

export default function Nav({ SignOut, changePage, setSidebarSections, activePlant }) {
  const isMobile = useMediaQuery("(max-width:720.9px)");
  const {data: allowedPlants} = useUserPowerplants()
  const {data: userRole} = useUserRole()
  const role = (userRole || '').toLowerCase()
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [settingsAnchorEl, setSettingsAnchorEl] = React.useState(null);

  const [openConfig, setOpenConfig] = React.useState(false);
  const [openSidebarConfig, setOpenSidebarConfig] = React.useState(false);
  const [configNoticeOpen, setConfigNoticeOpen] = React.useState(false);
  const [configNoticeMessage, setConfigNoticeMessage] = React.useState("");
  const [configNoticeSeverity, setConfigNoticeSeverity] = React.useState("success");
  React.useEffect(() => {
    if (!configNoticeOpen) return;
    const timer = setTimeout(() => setConfigNoticeOpen(false), 10000);
    return () => clearTimeout(timer);
  }, [configNoticeOpen]);
  const [pageAccess, setPageAccess] = React.useState({
    "CustomerPersona": false,
    "Graphs": false,
    "Config": false,
    "SidebarConfig": false,
    "MasterPage": false
  })
  const plantOptions = Array.isArray(allowedPlants)
    ? allowedPlants
    : (allowedPlants ? [allowedPlants] : []);

  const getCustomerPersonaKey = (plant) =>
    plant ? `CustomerPersona:${plant}` : "CustomerPersona";
  React.useEffect(()=>{
    const isManagement = role === 'management';
    setPageAccess({
      "CustomerPersona": true,
      "Graphs": true,
      "Config": !isManagement,
      "SidebarConfig": true,
      "MasterPage": true
    })
  }, [role])


  const open = Boolean(anchorEl);
  const settingsOpen = Boolean(settingsAnchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleSettingsClick = (event) => {
    setSettingsAnchorEl(event.currentTarget);
  };
  const handleSettingsClose = () => {
    setSettingsAnchorEl(null);
  };
  

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static" color="secondary" sx={{
        width: '99vw',
        left: '0.4vw',
        position: 'absolute',
        height: '70px',
        color: 'secondary'
      }}>
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            aria-controls={open ? 'basic-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClick}
            sx={{ mb: 0.5 }}
          >
            <MenuIcon />
          </IconButton>
          <Menu
            onClick={handleClose}
            onClose={handleClose}
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
          >
            {pageAccess.CustomerPersona == true && plantOptions.length === 0 && (
              <MenuItem onClick={() => changePage("CustomerPersona")}>Powerplant Dashboard</MenuItem>
            )}
            {pageAccess.CustomerPersona == true && plantOptions.length > 0 && plantOptions.map((plant) => (
              <MenuItem key={plant} onClick={() => changePage(getCustomerPersonaKey(plant))}>
                Powerplant Dashboard - {plant}
              </MenuItem>
            ))}
          </Menu>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            <a target="_blank" href='https://wisdm.energy' rel="noreferrer">
              <img src="/Logo.svg" alt="WISDM" className="logo" />
            </a>
          </Typography>
          {isMobile && (
            <IconButton
              size="large"
              edge="end"
              color="inherit"
              aria-label="settings"
              aria-controls={settingsOpen ? 'settings-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={settingsOpen ? 'true' : undefined}
              onClick={handleSettingsClick}
              sx={{ mb: 0.5 }}
            >
              <SettingsIcon />
            </IconButton>
          )}
          <Menu
            onClick={handleSettingsClose}
            onClose={handleSettingsClose}
            id="settings-menu"
            anchorEl={settingsAnchorEl}
            open={settingsOpen}
            MenuListProps={{
              'aria-labelledby': 'settings-button',
            }}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          >
            {pageAccess.MasterPage == true && (<MenuItem onClick={() => changePage("MasterPage")}>Master Overview</MenuItem>)}
            {pageAccess.Graphs == true && (<MenuItem onClick={() => changePage("GraphSelectorPage")}>Graphs</MenuItem>)}
            {pageAccess.Config == true && (<MenuItem onClick={() => setOpenConfig(true)}>Config</MenuItem>)}
            {pageAccess.SidebarConfig == true && (<MenuItem onClick={() => setOpenSidebarConfig(true)}>Sidebar Config</MenuItem>)}
            <MenuItem onClick={() => SignOut()}>Sign Out</MenuItem>
          </Menu>
          {!isMobile && pageAccess.MasterPage == true && (<Button variant="contained" color="success" onClick={() => {
            changePage("MasterPage");
          }} sx={{ height: '30px', fontSize: '1.5vh', mr: 2 }}>Master Overview</Button>)}
          {!isMobile && pageAccess.Graphs == true &&(<Button variant="contained" color="success" onClick={() => {
            changePage("GraphSelectorPage");
          }} sx={{ height: '30px', fontSize: '1.5vh', mr:2}}>Graphs</Button>)}
          {!isMobile && pageAccess.Config ==true && (<Button variant="contained" onClick={() => setOpenConfig(true)} sx={{ height: '30px', fontSize: '1.5vh', mr:2, backgroundColor: '#444', color: '#e7edf7', border: '1px solid #666',
            '&:hover': { backgroundColor: '#555' } }}>
            Config
          </Button>)}
          {!isMobile && pageAccess.SidebarConfig ==true && (<Button
            variant="contained"
            color="success"
            onClick={() => setOpenSidebarConfig(true)}
            sx={{ height: "30px", fontSize: "1.5vh", mr: 2 }}
          >
            Sidebar Config
          </Button>)}
          {!isMobile && <Button variant="contained" color="primary" onClick={() => {
            SignOut();
          }} sx={{ height: '30px', fontSize: '1.5vh'}}>Sign Out</Button>}
          
          {/* Adjust height and font size as needed */}
        </Toolbar>
        
      </AppBar>
          <ConfigPopup
          open={openConfig}
          onClose={() => setOpenConfig(false)}
          setOpen={setConfigNoticeOpen}
          setSeverity={setConfigNoticeSeverity}
          setMessage={setConfigNoticeMessage}
          plantName={activePlant}
        />
      <Dialog
        open={configNoticeOpen}
        onClose={() => setConfigNoticeOpen(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            backgroundColor: "#0b1422",
            color: "#e7edf7",
            border: "1px solid #22416b",
            borderRadius: "12px",
            boxShadow: "0 16px 36px rgba(10, 22, 42, 0.6)",
          },
        }}
      >
        <DialogTitle>
          {configNoticeSeverity === "error" ? "Save Failed" : "Saved"}
        </DialogTitle>
        <DialogContent dividers>
          {configNoticeMessage}
        </DialogContent>
        <DialogActions sx={{ justifyContent: "flex-end", px: 2, pb: 2 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => setConfigNoticeOpen(false)}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
        <SidebarConfigPopup
        open={openSidebarConfig}
        onClose={() => setOpenSidebarConfig(false)}
        onSave={(sections) => {
          setSidebarSections(sections); // pass back up to parent page
        }}
      />
    </Box>
  );
}
